import Images from "../../../../src/markdown-pages/press/images.mdx";
import Screenshots from "../../../../src/markdown-pages/press/screenshots.mdx";
import * as React from 'react';
export default {
  Images,
  Screenshots,
  React
};